export const applyReverseOpt = (d, layoutNameList) => {
  layoutNameList.forEach((layoutName) => {
    [...d.querySelectorAll(`.${layoutName}`)].forEach((layer) => {
      let datasetNode = layer.querySelector('.dataset');
      if (!datasetNode) datasetNode = layer.querySelector('.container__cards');

      const checkedReverseOpt = datasetNode.dataset.reverseOrder;

      if (checkedReverseOpt === 'true') {
        const items = layer.querySelectorAll('.container__card');
        items.forEach((item) => {
          item.parentNode.insertBefore(item, item.parentNode.firstChild);
        });
      }
    });
  });
};
